<!-- <mapfre-alert [closeButton]="true"></mapfre-alert> -->

<ng-container *ngIf="policy?.policyStatus !== 'FUTURE'">
  <div class="bn-alert-notice-wrapper">
    <app-bn-upcoming-payment-notice [policy]="policy"></app-bn-upcoming-payment-notice>
  </div>
</ng-container>
<div class="bn-notice-content bn-alert-notice-wrapper" *ngIf="policy?.isUnderRenewal">
    <app-renewal-notice [policy]='policy' [renewalPolicyList]='expiringLivoPolicyList'>
    </app-renewal-notice>
</div>
<ng-container *ngIf="policy?.isDelinquency">
    <div class="bn-error-notice-sec mb-4">
        <app-bn-error-notice [amount]='policy?.exitDelinquencyAmount?.theAmount'
            [date]='policy?.policyCancellationEffectiveDate'
            [policyCancellationReason]='policy?.policyCancellationReason' [policy]='policy'>
        </app-bn-error-notice>
    </div>
</ng-container>
<ng-container *ngIf="!policy?.hasAffinityGroup">
    <div class="bn-overview">
        <div class="bn-overview-left" [ngClass]="{'bn-overview-left-acmic':isAcmic}">
            <div
        *ngIf="!isAcmic && policy?.displayType?.label === 'Personal property' && policy?.billingDetails?.[0]?.mortageeFlag === 'Y'"
        class="display"
      >
        <div class="mortgagee-left margin-bottom mb-2">
          <span class="mortgagee-text lh-18">
            {{ 'MORTGAGEE_TEXT' | translate }}
          </span>
          <app-mortgagee-custom-tooltip></app-mortgagee-custom-tooltip>
        </div>
 
        <div *ngIf="policy?.billingDetails?.mortgagee && policy?.billingDetails?.mortgagee?.name && policy?.billingDetails?.mortgagee?.address" class="mortgagee-right">
          <div class="company-name lh-21">
            {{ policy?.billingDetails?.mortgagee?.name | titlecase}}
          </div>

            <div class="lh-24 mrb-1 h-21">
              {{ policy?.billingDetails?.mortgagee?.address?.line1 }}
            </div>

            <div class="lh-24 h-21">
              {{ policy?.billingDetails?.mortgagee?.address?.city }},
              {{ policy?.billingDetails?.mortgagee?.address?.state }}
              {{ policy?.billingDetails?.mortgagee?.address?.zip?.code }}
            </div>
          </div>
        </div>
        <ng-container *ngIf="policy?.isUnderRenewal && !isAcmic; else acmicOrNotInRenewal">
            <div class="term-row" >
                Renewal term {{ policy?.expDate | customDateFormat }}-{{ expRenewalDate | customDateFormat }}
            </div>
            <app-pif-discount 
              *ngIf="policy?.pifDiscountInfo?.pifEligible && !isPaidInFull" 
              [policy]="policy" 
              variant="bn-overview"
            ></app-pif-discount>
            <div *ngIf="renewalPolicyPremium && !hasPriorPif">
              <div class="bn-title-text mb-2">Renewal policy premium</div>
              <div class="dflex-align-center">
                <div class="bn-title-val">
                  {{ renewalPolicyPremium | currency }}
                </div>
                <div *ngIf="showRenewalNonDiscount" class="supporting-text supporting-marginleft">non discount</div>
              </div>
            </div>
            <app-pif-discount *ngIf="isPaidInFull" [policy]="policy" variant="bn-overview"></app-pif-discount>
            <app-bn-outstanding-balance
              [policy]="policy"
              [context]="paymentContext">
            </app-bn-outstanding-balance>
        </ng-container>
      <ng-template #acmicOrNotInRenewal>
        <app-pif-discount *ngIf="hasMidtermEndorsement" [policy]="policy" variant="bn-overview">
        </app-pif-discount>
        <div *ngIf="hasOutstandingBalance && policy?.paymentPlan && policy?.paymentPlan !== 'N/A' && (!policy?.pifDiscountInfo?.pifEligible || isPaidInFull === false) && (isAcmic || policy?.billingDetails?.[0]?.mortageeFlag !== 'Y')">
          <div class="bn-title-text mb-2" [ngClass]="{'bn-title-text-acmic':isAcmic}">
              <div class="d-flex" (click)="isMobile && toggleTooltip($event, payPlanTooltip)">
                  <div> {{ 'PAYMENT_PLAN' | translate }} </div>
                  <div class="ml-1">
                      <app-info-tooltip
                        #payPlanTooltip
                        [content]="'To change your payment plan, please contact our Customer Service team.'"
                        [position]="isMobile ? 'top' : 'bottom'"
                        align="left"
                        [edgeOffset]="isMobile ? 0 : 30">
                      </app-info-tooltip>
                  </div>
              </div>
          </div>
          <div class="bn-title-val" [ngClass]="{'bn-title-val-acmic':isAcmic}">{{
              policy?.paymentPlan?.replace('MAIP','') }}</div>
        </div>
        <app-pif-discount *ngIf="!hasMidtermEndorsement" [policy]="policy" variant="bn-overview">
        </app-pif-discount>
        <ng-container *ngIf="policy?.pifDiscountInfo?.pifEligible && !hasPriorPif && !isAcmic; else noPifEligible">
          <div>
            <div class="bn-title-text mb-2">Renewal policy premium</div>
            <div class="dflex-align-center">
              <div class="bn-title-val"> {{ renewalPolicyPremium | currency }} </div>
              <div class="supporting-text supporting-marginleft">non discount</div>
            </div>
          </div>
        </ng-container>
        <ng-template #noPifEligible>
          <div *ngIf="policy?.priorTotalPolicyPremium?.theAmount || policy?.totalPolicyPremium?.theAmount">
              <div class="bn-title-text" [ngClass]="{'bn-title-text-acmic':isAcmic}">Total policy premium*</div>
              <ng-container *ngIf="policy?.policynumber?.policyNumber?.length === 10">
                  <ng-container *ngIf="!policy?.isUnderRenewal && policy?.totalPolicyPremium?.theAmount">
                      <div class="bn-title-val mt-2" [ngClass]="{'bn-title-val-acmic':isAcmic}">{{
                          policy?.totalPolicyPremium?.theAmount | currency }}</div>
                  </ng-container>
                  <ng-container *ngIf="policy?.isUnderRenewal && policy?.priorTotalPolicyPremium?.theAmount">
                      <div class="bn-title-val mt-2" [ngClass]="{'bn-title-val-acmic':isAcmic}">{{
                          policy?.priorTotalPolicyPremium?.theAmount | currency }} </div>
                  </ng-container>
              </ng-container>
          </div>
        </ng-template>
            <app-bn-outstanding-balance
                [policy]="policy"
                [context]="paymentContext">
            </app-bn-outstanding-balance>
            <div *ngIf="policy?.policynumber?.policyNumber?.length === 10 && invoice && invoice?.documentId"
                class="view-invoice"
                [ngClass]="{'bn-invoice':!(policy?.policynumber?.policyNumber?.length === 10 && invoice && invoice?.documentId)}">
                <!-- <div class="bn-current-invoice">View current invoice</div> -->
                <div>
                    <span class="view-current-invoice" (click)="onDownloadDocument(invoice.documentId)"> {{
                        'VIEW_CURRENT_INVOICE' | translate }} </span>
                </div>
            </div>
          </ng-template>
        </div>
        <app-bn-payment-actions
          [policy]="policy"
          [context]="paymentContext"
        >
        </app-bn-payment-actions>
      <!-- </ng-template> -->
    </div>
</ng-container>

<hr class="hr-2 thin-hr">

<ng-container *ngIf="policy?.isUnderRenewal && !isAcmic">
  <div class="bn-overview">
    <div class="bn-overview-left">
      <div class="term-row" >
        Current term {{ policy?.effDate | customDateFormat }}-{{ policy?.expDate | customDateFormat }}
      </div>
      <div *ngIf="hasOutstandingBalance && policy?.paymentPlan && policy?.paymentPlan !== 'N/A' && (isAcmic || policy?.billingDetails?.[0]?.mortageeFlag !== 'Y')">
        <div class="bn-title-text mb-2">
          <div class="d-flex" (click)="isMobile && toggleTooltip($event, payPlanTooltip)">
            <div> {{ 'PAYMENT_PLAN' | translate }} </div>
            <div class="ml-1">
                <app-info-tooltip
                  #payPlanTooltip
                  [content]="'To change your payment plan, please contact our Customer Service team.'"
                  [position]="isMobile ? 'top' : 'bottom'"
                  align="left"
                  [edgeOffset]="isMobile ? 0 : 30">
                </app-info-tooltip>
            </div>
          </div>
        </div>
        <div class="bn-title-val">{{ policy?.paymentPlan?.replace('MAIP','') }}</div>
      </div>
      <div *ngIf="policy?.priorTotalPolicyPremium?.theAmount">
        <div class="bn-title-text mb-2">Total policy premium*</div>
        <div class="bn-title-val">
          {{ policy?.priorTotalPolicyPremium?.theAmount | currency }}
        </div>
      </div>
      <div 
        *ngIf="policy?.policynumber?.policyNumber?.length === 10 && invoice && invoice?.documentId"
        class="view-invoice"
      >
        <div>
          <span class="view-current-invoice" (click)="onDownloadDocument(invoice.documentId)">
            {{ 'VIEW_CURRENT_INVOICE' | translate }} 
          </span>
        </div>
      </div>
    </div>
  </div>
  <hr class="hr-2 thin-hr">
</ng-container>

<div *ngIf="nextBill && policy?.policyStatus === 'ACTIVE'">
    <div class="padding-bottom pb24">
        <div class="bn-title-text mb-2" [ngClass]="{'bn-title-text-acmic':isAcmic}">
          {{ isAcmic ? 'Next amount due**' : 'Next amount due***' }}
        </div>
        <div class="bn-title-val" [ngClass]="{'bn-title-val-acmic':isAcmic}">
            {{ nextBill?.minAmountDue | currency }} {{ ' on ' }} {{ nextBill?.dateDue | customDateFormat }}
        </div>
    </div>
    <div *ngIf="(policy?.policynumber.policyNumber.length !== 10 && policy?.policynumber.policyNumber.length === 6)">
        <hr class="hr-2 thin-hr">
    </div>
</div>
